<template>
  <div class="side-menu">
    <div class="site-name">
      <div class="img-wrap">
        <Logo />
      </div>
      <span class="company-name">{{ companyName }}</span>
    </div>
    <el-scrollbar class="side-menu-inner" tag="div">
      <div v-for="(menu, index) in tree" :key="menu.Guid">
        <template v-if="menu.Children.length > 0">
          <div
            class="has-sub-menu-inner"
            :class="{
              'sub-menu-open': menu.open,
              'has-sub-menu': menu.Children.length > 0,
            }"
            @click="collapseMenu(index)"
          >
            <!-- 主選單 -->
            <div @click="menuCategory = 'parents'">
              <div class="icon-wrap">
                <eva-icon
                  v-if="icon"
                  :name="icon[index]"
                  fill="#FFF"
                  width="18"
                />
              </div>
              <span v-if="menu.LocalizationalMenus.length > 0">
                <template v-for="language in menu.LocalizationalMenus">
                  <span
                    :key="language.LocalizationTypeGuid"
                    v-if="language.LocalizationTypeCode === currentLanguage"
                    style="color: #fff"
                  >
                    {{ language.MenuName ? language.MenuName : menu.MenuName }}
                  </span>
                </template>
              </span>
              <span v-else>
                {{ menu.MenuName }}
              </span>
            </div>
            <!-- 子選單 -->
            <ul>
              <li
                v-for="subMenu in menu.Children"
                :key="subMenu.Guid"
                @click="menuCategory = 'children'"
              >
                <!-- 外部連結 -->
                <template v-if="subMenu.ExternalLink">
                  <a :href="subMenu.Link" target="_blank">
                    <template v-for="language in subMenu.LocalizationalMenus">
                      <span
                        v-if="language.LocalizationTypeCode === currentLanguage"
                        :key="language.LocalizationTypeGuid"
                      >
                        {{
                          language.MenuName
                            ? language.MenuName
                            : subMenu.MenuName
                        }}
                      </span>
                    </template>
                  </a>
                </template>
                <!-- 內部連結 -->
                <template v-else>
                  <!-- 不開新視窗 -->
                  <router-link v-if="!subMenu.NewWindow" :to="subMenu.Link">
                    <div v-if="subMenu.LocalizationalMenus.length > 0">
                      <template v-for="language in subMenu.LocalizationalMenus">
                        <span
                          v-if="
                            language.LocalizationTypeCode === currentLanguage
                          "
                          :key="language.LocalizationTypeGuid"
                        >
                          {{
                            language.MenuName
                              ? language.MenuName
                              : subMenu.MenuName
                          }}
                        </span>
                      </template>
                    </div>
                    <span v-else>
                      {{ subMenu.MenuName }}
                    </span>
                  </router-link>
                  <!-- 開新視窗 -->
                  <a v-else :href="`${url}/#${subMenu.Link}`" target="_blank">
                    <div v-if="subMenu.LocalizationalMenus.length > 0">
                      <template v-for="language in subMenu.LocalizationalMenus">
                        <span
                          v-if="
                            language.LocalizationTypeCode === currentLanguage
                          "
                          :key="language.LocalizationTypeGuid"
                        >
                          {{
                            language.MenuName
                              ? language.MenuName
                              : subMenu.MenuName
                          }}
                        </span>
                      </template>
                    </div>
                    <span v-else>
                      {{ subMenu.MenuName }}
                    </span>
                  </a>
                </template>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Logo from "@/components/company/Logo.vue";

export default {
  name: "Manager_SideBar",

  components: {
    Logo,
  },
  data() {
    return {
      // Menu
      tree: [],
      icon: [],

      // url
      url: null,

      // 公司名稱
      companyName: null,

      // 選單類型
      menuCategory: "",

      // 目前語系
      currentLanguage: null,
    };
  },

  computed: {
    ...mapGetters(["editMenu"]),
  },

  watch: {
    editMenu() {
      if (this.editMenu) {
        this.getMenu();
      }
    },
  },

  methods: {
    // 摺疊菜單
    collapseMenu(index) {
      if (this.menuCategory === "parents") {
        this.tree[index].open = !this.tree[index].open;
      }
    },

    // 取得選單
    getMenu() {
      const vm = this;
      const api = `${window.endpoints.api}/auth/user/menu/${vm.$cookies.get(
        "Account"
      )}`;

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.tree = response.data.map((menu) => {
              return {
                ...menu,
                open: false,
              };
            });

            vm.icon = [];
            response.data.forEach((item) => {
              vm.icon.push(item.Icon);
            });
            const subMenu = response.data
              .map((element) => {
                return element.Children.map((subMenu) => {
                  return {
                    ...subMenu,
                    ParentLocalizationalMenus: element.LocalizationalMenus,
                  };
                });
              })
              .flat()
              .map((item) => {
                return {
                  Link: item.Link,
                  MenuName: item.MenuName,
                  ParentLocalizationalMenus: item.ParentLocalizationalMenus,
                  LocalizationalMenus: item.LocalizationalMenus,
                };
              });
            vm.$store.commit("EDITMENU", false);
            vm.$store.commit("SUBMENU", subMenu);
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$bus.$emit("message: push", error.response.data, "danger");
        });
    },

    // 取得公司名稱
    getCompanyName() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/companyname`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            this.companyName = response.data;
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "取得公司名稱失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },
  },

  created() {
    this.url = window.location.origin;
    this.getMenu();
    this.getCompanyName();
    this.currentLanguage = localStorage.getItem("i18n-lang");
  },
};
</script>

<style lang="scss" scoped>
$menu_color_darken: rgb(55, 55, 55);

.no-children-menu {
  margin-top: 8px;
  .icon-wrap {
    padding: 20px 20px;
    img {
      object-fit: contain;
      height: 100%;
      width: 100%;
    }
  }
  span {
    padding-left: 6px;
  }
}

.side-menu {
  background-color: $menu_color_darken;
  position: relative;
  width: 220px;
  border-right: 1px solid #ddd;
  transition: width 0.3s;
  height: 100vh;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  z-index: 100;
  .side-menu-inner {
    overflow-y: auto;
    flex: 1;

    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  @media screen and (max-width: 767px) {
    position: fixed;
    left: 0;
    right: 0;
    top: 50px;
    bottom: 0;
    z-index: 100;
    -webkit-overflow-scrolling: touch;
    transform: translateX(-100%);
    transition: all 0.3s;
  }

  .site-name {
    text-align: center;
    display: block;
    padding: 40px 0;
    color: #fff;
    text-decoration: none;
    .img-wrap {
      img {
        object-fit: contain;
        height: 100%;
        width: 100%;
      }
    }
    .company-name {
      margin-top: 15px;
    }

    span {
      display: block;
      text-align: center;
    }
  }

  .has-sub-menu {
    display: block;
    position: relative;
    cursor: pointer;
    color: #fff;

    &:after {
      content: ">";
      position: absolute;
      right: 15px;
      top: 10px;
      font-size: 0.8em;
      opacity: 0.7;
      -webkit-transition: -webkit-transform 0.3s;
      transition: transform 0.3s;
    }

    &.active {
      &:after {
        transform: rotate(90deg);
      }

      ul {
        max-height: 1500px;
      }
    }

    &.sub-menu-open {
      ul {
        max-height: 1500px;
      }

      &:after {
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
      }
    }
    .icon-wrap {
      width: 55px;
      height: 40px;
      line-height: 40px;
      margin-right: 10px;
      font-size: 0.9em;
      text-align: center;
      vertical-align: middle;
      display: inline-block;
    }
    span {
      line-height: 40px;
      border-radius: 15px;
    }

    ul {
      max-height: 0;
      list-style: none;
      transition: max-height 0.3s ease-in-out;
      overflow-y: hidden;
      margin-bottom: 0;
      padding-left: 20px;

      li {
        a {
          padding: 0.5rem 0.5rem;
          text-decoration: none;
          white-space: nowrap;
          padding-left: 50px;
          color: #fff;
          display: block;
          z-index: 10000;

          &.router-link-active {
            background-color: rgba(255, 255, 255, 0.1);
            border-radius: 25px;
          }
        }
      }
    }
  }

  .sidebar-minimizer-btn {
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: right;
    i {
      width: 55px;
      height: 55px;
      line-height: 55px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;
    }
  }
}
</style>
